<div
  class="w-100 h-100 mx-2"
  *ngIf="activityData?.api"
>
  <mng-booking-webcomponent
    [backendApiUrl]="activityData?.api"
    [backendApiUrlV2]="activityData?.apiV2"
    [language]="language"
    [resourceId]="activityData?.metadata?.resourceId || ''"
    [eventTypeId]="activityData?.metadata?.eventTypeId || null"
    [isRoot]="activityData?.calendarRoot || false"
    [token]="token"
    [resource]="activityData?.metadata?.resource || null"
    [editEvent]="activityData?.calendarEdit || false"
    [initStatus]="activityData?.calendarStatus || 'pending'"
    [eventId]="activityData?.metadata?.eventId"
    (eventEmitterActionBooking)="onNewAppointment($event)">
  </mng-booking-webcomponent>

</div>
